<template>
  <VeProgressAsync v-bind="$attrs" />
</template>

<script setup lang="ts">
// vue-ellipse-progress is a 116 KB UMD build (core-js polyfills included) that the global plugin put in the
// entry chunk of every page. The gauges (account header, badges, reward modal) are client-only: the library is
// now loaded with the first gauge shown. The templates keep using <ve-progress>, resolved to this component.
defineOptions({ inheritAttrs: false })

const VeProgressAsync = defineAsyncComponent(() =>
  import('vue-ellipse-progress').then(
    (module) => module.VeProgress ?? module.default?.VeProgress,
  ),
)
</script>
